import type {
  GraphQL,
  ProductCheapestAvailabilityResponse,
} from '@libs/trip-planner-interfaces';

import { assertSmartSearchList, assertSmartSearchValue } from '../../utils';

import { toMoney } from './moneyResponseQL';
import { toBoardBasisCode } from './boardBasisCodeQL';

export function toDestinationAvailabilityResponseQL(
  destinationAvailabilityResponseQL: GraphQL.searchDestinationAvailabilitySubscription
): ProductCheapestAvailabilityResponse {
  assertSmartSearchValue(
    destinationAvailabilityResponseQL.getCheapestStayByHotel
  );
  const destinationAvailabilityResponse =
    destinationAvailabilityResponseQL.getCheapestStayByHotel;

  assertSmartSearchValue(destinationAvailabilityResponse.prices);
  assertSmartSearchValue(destinationAvailabilityResponse.prices.totalPrice);

  assertSmartSearchList(destinationAvailabilityResponse.rooms);
  assertSmartSearchValue(destinationAvailabilityResponse.placeCode);

  return {
    date: new Date(destinationAvailabilityResponse.date),
    placeCode: destinationAvailabilityResponse.placeCode,
    prices: {
      totalPrice: toMoney(destinationAvailabilityResponse.prices.totalPrice),
      grossPrice: destinationAvailabilityResponse.prices.grossPrice
        ? toMoney(destinationAvailabilityResponse.prices.grossPrice)
        : undefined,
      priceIsWithTaxesIncluded:
        !!destinationAvailabilityResponse.prices.priceIsWithTaxesIncluded,
    },
    rooms: destinationAvailabilityResponse.rooms.map((room) => ({
      boardBasis: room.boardBasis
        ? toBoardBasisCode(room.boardBasis)
        : undefined,
    })),
  };
}
